// src/pages/PackageList.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, where } from 'firebase/firestore'; // 'where' is not needed but good practice to keep
import { db } from '../firebase';
import './PackageList.css'; 
import PackageSlider from '../Components/PackageSlider';

const PackageList = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCategoriesAndPrices = async () => {
            try {
                // Fetch both categories and packages in parallel for efficiency
                const [categoriesSnapshot, packagesSnapshot] = await Promise.all([
                    getDocs(collection(db, "categories")),
                    getDocs(collection(db, "packages"))
                ]);

                const categoriesData = categoriesSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                const packagesData = packagesSnapshot.docs.map(doc => doc.data());

                // ✅ Map through categories to find the minimum price for each
                const categoriesWithMinPrice = categoriesData.map(category => {
                    const relevantPackages = packagesData.filter(pkg => pkg.category === category.id && pkg.price > 0);
                    
                    let minPrice = null;
                    if (relevantPackages.length > 0) {
                        minPrice = Math.min(...relevantPackages.map(pkg => pkg.price));
                    }
                    
                    return { ...category, minPrice };
                });

                setCategories(categoriesWithMinPrice);

            } catch (err) {
                console.error("Error fetching data:", err);
                setError("Failed to load cuisines.");
            } finally {
                setLoading(false);
            }
        };
        fetchCategoriesAndPrices();
    }, []);

    const handleCategoryClick = (categoryId) => {
        navigate(`/category/${categoryId}/meals`);
    };

    if (loading) return <div className="status-message">Loading Cuisines...</div>;
    if (error) return <div className="status-message error">{error}</div>;

    return (
        <div className="package-list-container">
            
            <PackageSlider />

            <div className="row g-5">
                {categories.map(category => (
                    <div className="col-lg-3 col-md-6" key={category.id}>
                        <div className="product-wrapper-link" onClick={() => handleCategoryClick(category.id)}>
                            <div className="product-wrapper">
                                <div className="card-image-top">
                                    <img src={category.imageUrl} alt={category.name}/>
                                </div>
                                <div className="wrapper-info">
                                    <h3 className="wrapper-details">{category.name}</h3>
                                    <h5 className="wrapper-details">{category.description || 'View our delicious plans'}</h5>
                                    
                                    {/* ✅ RENDER THE MINIMUM PRICE IF IT EXISTS */}
                                    {category.minPrice !== null ? (
                                        <h5 className="wrapper-price">Starts at ₹{category.minPrice}</h5>
                                    ) : (
                                        // Optional: A placeholder if no price is found
                                        <h5 className="wrapper-price">&nbsp;</h5>
                                    )}

                                    <div className="order-now-btn">Order Now</div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PackageList;